var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnContents1X({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6878 3H4.55556C3.7 3 3 3.7 3 4.55556V15.4444C3 16.3 3.7 17 4.55556 17H15.4444C16.3 17 17 16.3 17 15.4444V8.31222C17 7.9 16.8367 7.50333 16.5411 7.21556L12.7844 3.45889C12.4967 3.16333 12.1 3 11.6878 3ZM6.88889 12.3333H13.1111C13.5389 12.3333 13.8889 12.6833 13.8889 13.1111C13.8889 13.5389 13.5389 13.8889 13.1111 13.8889H6.88889C6.46111 13.8889 6.11111 13.5389 6.11111 13.1111C6.11111 12.6833 6.46111 12.3333 6.88889 12.3333ZM6.88889 9.22222H13.1111C13.5389 9.22222 13.8889 9.57222 13.8889 10C13.8889 10.4278 13.5389 10.7778 13.1111 10.7778H6.88889C6.46111 10.7778 6.11111 10.4278 6.11111 10C6.11111 9.57222 6.46111 9.22222 6.88889 9.22222ZM6.88889 6.11111H10.7778C11.2056 6.11111 11.5556 6.46111 11.5556 6.88889C11.5556 7.31667 11.2056 7.66667 10.7778 7.66667H6.88889C6.46111 7.66667 6.11111 7.31667 6.11111 6.88889C6.11111 6.46111 6.46111 6.11111 6.88889 6.11111Z",
    fill: "#8B95A1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnContents1X);
export default __webpack_public_path__ + "static/media/icn-contents@1x.6b647f15.svg";
export { ForwardRef as ReactComponent };